<template>
  <div class="twui-console" style="margin:0 100px; background:#fff; padding:0 60px 60px;">
    <tw-page-title>图标及按钮</tw-page-title>

    <!-- 工具栏 -->
    <div class="twui-toolbar">
      <a class="twui-btn xborder xlarge" @click="dialogAdd = true"><i class="twui-ico xadd"></i>新增</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico xmodify"></i>修改</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico xdownload"></i>下载</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico xdel"></i>删除</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico ximport"></i>导入</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico xlink"></i>关联角色</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico xvc"></i>查看审核</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico xconvert"></i>升级脚本</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico xupgrade"></i>关联角色</a>
      <a class="twui-btn xborder xlarge"><i class="twui-ico xlock"></i>重置密码</a>
    </div>
    <!-- /工具栏 -->

    <tw-page-title style="margin-bottom:15px;">弹窗</tw-page-title>


    <a class="twui-btn xborder xlarge" @click="dialogAccess = true">左右选择</a>

      <!-- 弹窗:左右选择弹窗 -->
      <el-dialog class="twui-xmodal-base" title="左右选择弹窗" :visible.sync="dialogAccess" size="large" close-on-click-modal="false">
        <el-transfer v-model="selectedList" :data="data"></el-transfer>
        <div slot="footer" class="dialog-footer">
          <button class="twui-btn xmain xlarge" @click="dialogAccess = false">保存</button>
          <button class="twui-btn xborder xlarge" @click="dialogAccess = false">取消</button>
        </div>
      </el-dialog>
      <!-- /弹窗:左右选择弹窗 -->
  </div>
</template>

<script>
  export default {
    name: 'style',
    data () {
      return {
        dialogAccess: false,
        selectedList: [],
        data: [
          {
            key: 1,
            lagel: '选项1'
          },
          {
            key: 2,
            lagel: '选项2'
          }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// style.vue?00cfbcd4